import React from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const InstagramFeed = () => {
  const instagramPosts = [
  {
    id: 1,
    image: "https://images.unsplash.com/photo-1731406499714-039ee423348e",
    imageAlt: "Golden flaky croissants fresh from oven arranged artistically on marble counter with morning sunlight streaming through bakery window",
    likes: 342,
    caption: "Fresh cornetti every morning at 6 AM! ☀️🥐"
  },
  {
    id: 2,
    image: "https://images.unsplash.com/photo-1732361551253-52d03322869b",
    imageAlt: "Rustic artisan bread loaves with golden crispy crust displayed on wooden shelves in traditional Italian bakery setting",
    likes: 289,
    caption: "Artisan sourdough perfection 🍞✨"
  },
  {
    id: 3,
    image: "https://images.unsplash.com/photo-1561702856-b4ec96854ed8",
    imageAlt: "Elegant three-tier wedding cake with white fondant decorated with fresh roses and gold accents on display pedestal",
    likes: 456,
    caption: "Custom wedding cake dreams come true 💍🎂"
  },
  {
    id: 4,
    image: "https://images.unsplash.com/photo-1701351348533-ceeee1446329",
    imageAlt: "Colorful Italian gelato display with multiple flavors in metal containers including pistachio mint chocolate and strawberry",
    likes: 378,
    caption: "Authentic Italian gelato made daily 🍨❤️"
  },
  {
    id: 5,
    image: "https://images.unsplash.com/photo-1697716681623-658d2c24fd8f",
    imageAlt: "Decadent chocolate cake slice with multiple layers of rich ganache and chocolate shavings on white porcelain plate",
    likes: 412,
    caption: "Chocolate lovers paradise 🍫😍"
  },
  {
    id: 6,
    image: "https://images.unsplash.com/photo-1692098075745-016626ed54ff",
    imageAlt: "Assorted Italian pastries including cannoli sfogliatelle and biscotti arranged on vintage ceramic platter with espresso cups",
    likes: 325,
    caption: "Traditional Italian pastries 🇮🇹✨"
  }];


  return (
    <section className="py-16 bg-background">
      <div className="container-custom">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-accent/10 border border-accent/20 mb-4">
            <Icon name="Instagram" size={16} color="var(--color-accent)" />
            <span className="text-sm font-medium text-accent">@montesantobakery</span>
          </div>
          <h2 className="font-serif text-4xl font-bold text-foreground mb-4">
            Follow Our Daily Journey
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            See what's fresh today and join our community of Italian food lovers
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 mb-8">
          {instagramPosts?.map((post) =>
          <div
            key={post?.id}
            className="group relative aspect-square rounded-xl overflow-hidden cursor-pointer">

              <Image
              src={post?.image}
              alt={post?.imageAlt}
              className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" />

              <div className="absolute inset-0 bg-gradient-to-t from-background/90 via-background/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-0 left-0 right-0 p-4">
                  <div className="flex items-center gap-2 text-primary-foreground">
                    <Icon name="Heart" size={16} className="fill-current" />
                    <span className="text-sm font-medium">{post?.likes}</span>
                  </div>
                  <p className="text-xs text-primary-foreground/90 mt-2 line-clamp-2">
                    {post?.caption}
                  </p>
                </div>
              </div>
            </div>
          )}
        </div>

        <div className="text-center">
          <a
            href="https://instagram.com/montesantobakery"
            target="_blank"
            rel="noopener noreferrer">

            <Button variant="outline" size="lg" iconName="Instagram" iconPosition="left">
              Follow Us on Instagram
            </Button>
          </a>
        </div>
      </div>
    </section>);

};

export default InstagramFeed;